import translations from '../../../translations';
import type { AttributeMappings, IdentityProviderAPI } from '../../../types/identityProvider';
import VariablePicker from '../../generic/environmentVariablePicker/VariablePicker';
import FormGroup from '../../generic/FormGroup';
import Table, { type TableColumnList } from '../../generic/Table';

interface Props {
    item: IdentityProviderAPI;
    header: string;
    onChange: (name: string, value: string) => void;
    displayVariablePicker: boolean;
}

const IdentityProviderAttributeMappings = ({
    item,
    header,
    onChange,
    displayVariablePicker,
}: Props) => {
    const attributeMappingColumns: TableColumnList<AttributeMappings> = [
        {
            renderHeader: () => translations.COMMON_TABLE_name,
            renderCell: ({ item }) => item['label'],
            size: '20rem',
        },
        {
            renderHeader: () => header,
            renderCell: ({ item }) => (
                <VariablePicker
                    onSelect={(variableName: string) => onChange(item['id'] ?? '', variableName)}
                    isVisible={displayVariablePicker}
                >
                    <input
                        type="text"
                        className="form-control"
                        value={item['value'] ?? ''}
                        onChange={(e) => onChange(item['id'] ?? '', e.currentTarget.value)}
                        data-testid={`attribute-${item['id'] ?? ''}`}
                    />
                </VariablePicker>
            ),
        },
    ];

    const attributeMappings: { label: string; id: string; value: string }[] = Object.keys(
        item.attributeMappings ?? {},
    )
        .sort()
        .map((key) => {
            const label = (translations as Record<string, string>)[
                `IDENTITY_PROVIDER_attributes_${key}`
            ];

            return {
                label: label ?? '',
                id: key,
                value: item.attributeMappings[key] ?? '',
            };
        });

    return (
        <FormGroup label="Custom Attribute Mappings">
            <Table<AttributeMappings>
                wrapperClassName="margin-top"
                columns={attributeMappingColumns}
                items={attributeMappings}
                testId="attribute-mappings"
            />
        </FormGroup>
    );
};

export default IdentityProviderAttributeMappings;
